<script>
/*
<template>
    <span class="ec-inline-live-formula" v-html="lfContent"></span>
</template>
*/
import { has } from 'lodash'
import { placeholderFormater } from '../../utility'

export default Vue.component('live-formula', {
    name: "LiveFormula",
    data: function() { return {
        formula: null,
        decimals: 0,
        loading: false,
        value: "0"
    }},
    computed: {
        lfContent: function() {
            if(this.loading || this.$store.recalculating) {
                return '<i class="fa fa-spinner fa-spin"></i>'
            }

            this.$nextTick(function() {
                placeholderFormater(this.$el, this.decimals)
            })

            return this.value
        }
    },
    created() {
        this.$store.liveFormulas.push(this)

        this.$event.$on('start-recalculation', () => {
            this.loading = true
        })

        this.$event.$on('new-data', this.newData)
    },
    mounted() {
        this.loading = false
    },
    methods: {
        newData(payload) {
            if(has(payload, 'formulas.' + this.formula)) {
                this.value = payload.formulas[this.formula]
            }
            
            this.loading = false
        }
    },
})
</script>